/* eslint-disable max-len */
import React from 'react';
import { FooterText } from './styles/FooterStyles';

export const Footer = () => {
  return (
    <FooterText>Created by Annika Sonnek - student at Technigo&apos;s Web Developer Bootcamp spring&apos;23</FooterText>
  )
}

